import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import Choice from './Choice';
import { backSizesData } from '../../data/sizes';
import { sizeQuizMessages as messages } from '../../data/messages';

import { updateSizeSelection } from '../../utils/helpers';

const BackSizes = props => {
  const {
    backSizes,
    intl: { formatMessage },
    setBackSize,
    setBackSizes,
    setTempBackCache,
  } = props;

  useEffect(() => {
    setBackSizes(backSizesData);
  }, []);

  return (
    <div className="sizes sizes__back">
      <p>{formatMessage(messages.chooseBackSize)}</p>
      <div>
        {backSizes.map((backSize, idx) => (
          <Choice
            key={idx}
            size={backSize.size}
            toggleFunction={() => {
              setBackSizes(updateSizeSelection(backSizes, backSize.size));
              setTempBackCache(backSize.size);
              setBackSize(backSize.size);
            }}
            isChecked={backSize.selected}
            newName="backSize"
          />
        ))}
      </div>
    </div>
  );
};

BackSizes.propTypes = {
  backSizes: PropTypes.array,
  intl: intlShape,
  setBackSize: PropTypes.func,
  setBackSizes: PropTypes.func,
  setTempBackCache: PropTypes.func,
};

export default injectIntl(BackSizes);
